import { BorderGridContainer, GridBox, P, PortableText } from '@ahmdigital/ui';

import { AwardImage, ImageWrapper, StyledSection, TextWrapper } from './styles';
import { SectionAwardType } from '../../types';
import getImageAttributes from '../../../../cms/utils/get-image-attributes';

const Award = ({ imageObject, name, summaryRaw }: SectionAwardType) => {
  const image = getImageAttributes({ height: 200, imageObject });

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <StyledSection variant={['paddingTopSpacer10', 'paddingBottomSpacer10']}>
          <ImageWrapper>{image && <AwardImage alt={image.alt} src={image.src} />}</ImageWrapper>
          <TextWrapper>
            <P looksLike="h3" variant={['simpleBit', 'marginBottomSpacer12']}>
              {name}
            </P>
            <PortableText source={summaryRaw} />
          </TextWrapper>
        </StyledSection>
      </GridBox>
    </BorderGridContainer>
  );
};

export default Award;
